import { Address } from '@ton/core';
import { CHAIN } from '@tonconnect/ui-react';

export const getTonAddressUserFriendly = (address: string, chain?: CHAIN): string => {
  try {
    const addr = Address.parse(address);
    const isTestnet = chain === CHAIN.TESTNET;
    return addr.toString({
      testOnly: isTestnet,
      bounceable: false,
      urlSafe: true,
    });
  } catch {
    return address;
  }
};

export const formatTonAddress = (address: string, chain?: CHAIN): string => {
  const userFriendly = getTonAddressUserFriendly(address, chain);
  return `${userFriendly.slice(0, 6)}...${userFriendly.slice(-4)}`;
};
